// -----------------------------------------------------------------------------
export class OWInternalUtils {
  // ---------------------------------------------------------------------------
  public static async getPersistentPhasedPercent(): Promise<number> {
    return new Promise(resolve => {
      overwolfInternal.utils.getPersistentPhasedPercent(response => {
        resolve(response.phasedPercent);
      });
    });
  }

  // ---------------------------------------------------------------------------
  public static async isAnyNotificationDisplayed(): Promise<boolean> {
    return new Promise(resolve => {
      overwolfInternal.utils.isAnyNotificationDisplayed(response => {
        const res = response &&
                    response.status === 'success' &&
                    response.displayed === true;

        resolve(res);
      });
    });
  }

  // ---------------------------------------------------------------------------
  public static collectLogs(): Promise<boolean> {
    return new Promise(resolve => {
      overwolfInternal.utils.createLogsZip(res => {
        resolve(res.status === 'success');
      });
    });
  }

}
